module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "clearfix"
  }, [_c('ul', {
    staticClass: "nav navbar-nav flex-row float-right nav-icon text-center",
    attrs: {
      "id": "HeaderRightMenuList"
    }
  }, [_c('li', {
    staticClass: "nav-item nav-item-menu",
    style: ({
      height: _vm.headerHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "btn btn-group w-100 h-100 py-1 px-1",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('a', {
    staticClass: "nav-menu-click-cover",
    attrs: {
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "nav-icon nav-link nav-menu",
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_c('i', {
    staticClass: "fa fa-list",
    class: _vm.iconSizeClass,
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "0.5em"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][8]"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right py-0 my-0"
  }, [_c('div', [_c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][12]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][15]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][13]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][14]",
      "adjustLangFontSizes": {
        en: 0.8
      }
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][17]"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)",
      "data-toggle": "modal",
      "data-target": "#CanNotOperateWithinDemoAlert"
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[1][7]"
    }
  })], 1), _vm._v(" "), (_vm.isLoggedInPage) ? _c('a', {
    staticClass: "dropdown-item",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('trans-text', {
    attrs: {
      "i18nKey": "ui[12][1]"
    }
  })], 1) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c241607a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/partials/HeaderRightMenuMobile.vue
// module id = 729
// module chunks = 0